import axios from 'axios';
import moment from 'moment';
const mixin = {
    data() {
        return {
            th: this.$thaidate,
            axios: axios,
            // width 1/
            window: {
                width: 0,
                height: 0
            }
        };
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        checkToken() {
            const token = localStorage.getItem('token');
            const tokenExp = localStorage.getItem('token_exp');

            if (!token || !tokenExp) {
                this.logout();
                return false;
            }

            const remainingTime = new Date(tokenExp) - Date.now();

            if (remainingTime <= 0) {
                localStorage.removeItem('token');
                localStorage.removeItem('token_exp');
                this.logout();
                return false;
            }

            const decodedToken = this.decodeJWT(token);

            if (decodedToken == null || decodedToken == 'failed login') {
                localStorage.removeItem('token');
                localStorage.removeItem('token_exp');
                this.logout();
                return false;
            }

            return true;
        },

        logout() {
            console.log('Logging out due to token expiration...');
            localStorage.removeItem('token');
            localStorage.removeItem('token_exp');
            localStorage.removeItem('data');
            localStorage.removeItem('username');
            localStorage.removeItem('session');
            location.reload(); // Reload to clear any state
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        getUsername() {
            const token = localStorage.getItem('token');
            if (token) {
                const userData = this.decodeJWT(token);
                return userData ? userData.user_id : null;
            }
            return null;
        },

        getUsername_userName() {
            const token = localStorage.getItem('token');
            if (token) {
                const userData = this.decodeJWT(token);
                return userData ? userData.user_username : null;
            }
            return null;
        },

        getUserOrganize() {
            const token = localStorage.getItem('token');
            if (token) {
                const userData = this.decodeJWT(token);
                if (userData) {
                    let result = userData.organize_id;
                    if (result === 'or-000025') {
                        return 'or-000024';
                    }
                    if (result === 'or-000036') {
                        return 'or-000035';
                    }
                    if (result === 'or-000048') {
                        return 'or-000047';
                    }
                    if (result === 'or-000057') {
                        return 'or-000056';
                    }
                    if (result === 'or-000065') {
                        return 'or-000064';
                    }
                    if (result === 'or-000076') {
                        return 'or-000075';
                    }
                    return result;
                }
            }
            return null;
        },

        getUserPermiss() {
            const token = localStorage.getItem('token');
            if (token) {
                const userData = this.decodeJWT(token);
                return userData ? userData.permission_id : null;
            }
            return null;
        },

        checkNotAdminPermission(data) {
            const userPermiss = this.getUserPermiss();
            const resultOrg = this.getUserOrganize();
            const paramsOrg = data;

            if (userPermiss === 'pl-000001') {
                return true;
            } else {
                return resultOrg === paramsOrg;
            }
        },

        checkDiv14() {
            const token = localStorage.getItem('token');
            if (token) {
                const userData = this.decodeJWT(token);
                if (userData) {
                    return userData.organize_id !== 'or-000008';
                }
            }
            return true;
        },

        checkPermission() {
            const token = localStorage.getItem('token');
            if (token) {
                const userData = this.decodeJWT(token);
                if (userData) {
                    const result = userData.permission_id;
                    const div_14 = userData.organize_id;
                    // ดูข้อมูลและแก้ไขได้ทุกหน่วยงาน (pl-000001)
                    if (result === 'pl-000001') {
                        return true;
                    } else {
                        return div_14 === 'or-000008';
                    }
                }
            }
            return false;
        },
        
        formatTime(str) {
            return moment(str).format('YYYY-MM-DD [เวลา] HH:mm:ss');
        },
        Format_Time(time) {
            // string and date ค.ศ ไป string พ.ศ.
            const data_check = time instanceof Date && !isNaN(time.valueOf());

            if (typeof time === 'string') {
                const element = time.split('/');
                const dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`);
                const result_Date = dateNew.toLocaleDateString('th-TH', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                return result_Date;
            } else if (data_check) {
                const result_Date = time.toLocaleDateString('th-TH', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                return result_Date;
            }

            return moment(time).locale('th').add(543, 'year').format('LL');
        },
        formatTimeTH(time) {
            let dateNew;
            let dataReturn;

            if (time !== null) {
                for (let i = 0; i < time.length; i++) {
                    const element = time.split('/', 3);
                    const ee = element[2].split(' ');
                    dateNew = new Date(`${element[1]}/${element[0]}/${ee[0]} ${ee[1]}`);
                }
                dataReturn = moment(dateNew).locale('th').add(543, 'year').format('DD/MM/YYYY [เวลา] HH:mm:ss');
            } else {
                dataReturn = '';
            }
            return dataReturn;
        },
        formatDateTH(time) {
            let dateNew;
            let dataReturn;
            if (time !== null) {
                for (let i = 0; i < time.length; i++) {
                    const element = time.split('/');
                    dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`);
                }
                dataReturn = moment(dateNew).locale('th').add(543, 'year').format('DD/MM/YYYY');
            } else {
                dataReturn = '';
            }
            return dataReturn;
        },
        formatDateString(val) {
            // จาก string ค.ศ ไป string พ.ศ
            if (typeof val === 'string') {
                const element = val.split('/');
                val = new Date(element[2], element[1] - 1, element[0]);
                const result_Date = val.toLocaleDateString('th-TH', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
                return result_Date;
            }
            return val;
        },
        formatDateString_RESET(val) {
            // จาก  string พ.ศ ไป string ค.ศ
            if (typeof val === 'string') {
                const element = val.split('/');
                const date_String = `${element[2] - 543}/${element[1]}/${element[0]}`;
                return date_String;
            }
            return val;
        },
        formatTopic(str) {
            if (str.includes('suggestion')) {
                return 'ข้อเสนอแนะ';
            } else if (str.includes('permission')) {
                return 'ระดับสิทธิ์';
            } else if (str.includes('system user')) {
                return 'ผู้ใช้งานระบบ';
            } else if (str.includes('menu')) {
                return 'เมนูการใช้งาน';
            } else if (str.includes('general system')) {
                return 'พื้นฐานระบบ';
            } else if (str.includes('province')) {
                return 'จังหวัด';
            } else if (str.includes('amphur')) {
                return 'อำเภอ';
            } else if (str.includes('tambon')) {
                return 'ตำบล';
            } else if (str.includes('evacuation')) {
                return 'พื้นที่อพยพ';
            } else if (str.includes('risk level')) {
                return 'ระดับความเสี่ยง';
            } else if (str.includes('risk area')) {
                return 'พื้นที่เสี่ยงภัย';
            } else if (str.includes('organize')) {
                return 'หน่วยงาน';
            } else if (str.includes('prevent')) {
                return 'ระบบป้องกัน/บรรเทาสาธารณภัย';
            } else if (str.includes('course')) {
                return 'หลักสูตรการฝึกอบรม';
            } else if (str.includes('officer')) {
                return 'กำลังคน';
            } else if (str.includes('device')) {
                return 'อุปกรณ์';
            } else if (str.includes('incident')) {
                return 'ชุดเผชิญเหตุ';
            } else if (str.includes('equipment')) {
                return 'เครื่องมือ อุปกรณ์/ยานพาหนะ';
            } else if (str.includes('building')) {
                return 'อาคาร/สิ่งปลูกสร้าง';
            } else if (str.includes('UN')) {
                return 'UN Number (สารเคมี)';
            } else if (str.includes('fire hydrant') || str.includes('firehy drant')) {
                return 'หัวจ่ายน้ำดับเพลิง';
            } else if (str.includes('community')) {
                return 'ชุมชน';
            } else if (str.includes('firestation')) {
                return 'สถานีดับเพลิงและกู้ภัย';
            } else if (str.includes('disaster')) {
                if (str.includes('people')) {
                    return 'สาธารณภัย (แจ้งเหตุจากประชาชน)';
                } else {
                    return 'สาธารณภัย';
                }
            } else if (str.includes('family')) {
                return 'ครอบครัวผู้ประสบภัย';
            } else if (str.includes('person')) {
                return 'ผู้ประสบภัย (บุคคล)';
            } else if (str.includes('consumables')) {
                return 'เครื่องอุปโภค บริโภค';
            } else if (str.includes('extinguisher')) {
                return 'ถังดับเพลิง';
            } else if (str.includes('EV station')) {
                return 'สถานีชาร์จรถยนต์ไฟฟ้า';
            } else if (str.includes('public organization')) {
                return 'สถานประกอบการ';
            } else if (str.includes('volunteer')) {
                return 'อาสาสมัคร อปพร.';
            } else if (str.includes('Volunteer Rescue')) {
                return 'จุดอาสาสมัคร';
            } else if (str.includes('manual')) {
                return 'คู่มือการใช้งานระบบ';
            } else if (str.includes('Volunteer Civil')) {
                return 'อาสาสมัคร อปพร';
            } else if (str.includes('Disaster (map)')) {
                return 'ประชาชนแจ้งเหตุ';
            } else if (str.includes('Volunteer Bangkok')) {
                return 'อาสาสมัครในพื้นที่เขตกรุงเทพมหานคร';
            }
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
            return this.window;
        },
        tableColSticky(width, textAlign, position, setPosition) {
            if (position === 'sticky') {
                const setStyle = {
                    width: width,
                    textAlign: textAlign !== '' ? textAlign : 'left',
                    border: '1px solid #d6d4d4',
                    zIndex: '1',
                    position: position,
                    [setPosition]: '0'
                };
                return setStyle;
            } else {
                const setStyle = {
                    width: width,
                    textAlign: textAlign !== '' ? textAlign : 'left',
                    border: '1px solid #d6d4d4',
                    zIndex: '1'
                };
                return setStyle;
            }
        },
        tableColNone() {
            const setStyle = { width: '0', padding: '0', border: 'none' };
            return setStyle;
        },
        checkInnerWidth(widthRow, Status) {
            if (Status === 'Body') {
                const setStyle = {
                    width: widthRow,
                    textAlign: 'center',
                    position: 'sticky',
                    right: '0',
                    // zIndex:'10',
                    backgroundColor: 'white',
                    padding: '0',
                    borderLeft: '1px solid #d6d4d4'
                };
                return setStyle;
            } else {
                const setStyle = {
                    width: widthRow,
                    textAlign: 'center',
                    position: 'sticky',
                    // right:window.innerWidth > 991 ?'17px':'0px',
                    top: '0',
                    right: '0',
                    // border:'none',
                    border: '1 px solid #d6d4d4',
                    zIndex: '1'
                };
                return setStyle;
            }
        },
        changeDateToThai(date) {
            if (typeof date === 'object') {
                const Thai_date = date.toLocaleDateString('th-TH', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                return Thai_date;
            } else {
                return date;
            }
        },
        checkDate(date, type) {
            if (this.isDate(date) && date !== null) {
                return date;
            } else {
                return this.changePositionDate_MaxMin(date, type);
            }
        },
        checkDate_showEN(date) {
            // ให้แสดงเป็น 00/00/0000
            if (this.isDate(date) && date !== null) {
                return this.changeDateToEN(date);
            } else {
                return date.length === 10 ? date : '';
            }
        },
        isDate(value) {
            if (typeof value === 'object') {
                const date = new Date(value);
                return !isNaN(date.getTime());
            } else {
                return false;
            }
        },
        checkInvalid_Date(date, type) {
            if (date === 'Invalid Date') {
                return type === 'null' ? null : 'รูปแบบวันที่ไม่ถูกต้อง';
            } else {
                return date;
            }
        },
        changeDateToEN(date, symbol) {
            const ye2 = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
            const mo2 = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
            const da2 = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
            if (symbol !== undefined && symbol !== '' && symbol !== null) {
                const New_date = `${ye2}${symbol}${mo2}${symbol}${da2}`;
                return New_date;
            } else {
                const New_date = `${da2}/${mo2}/${ye2}`;
                return New_date;
            }
        },
        changePositionDate_MaxMin(date, type) {
            if (date !== null && date !== '' && date.length === 10) {
                const dateNew = date.split('/');
                const sendDate = new Date(`${dateNew[2]}/${dateNew[1]}/${dateNew[0]}`);
                return sendDate;
            } else {
                const newDate = new Date(date);
                if (date !== null && date.length > 10 && newDate !== 'Invalid Date') {
                    return newDate;
                } else {
                    return type === 'null' ? null : '';
                }
            }
        },
        setTimeMaxMin(time) {
            if (typeof time === 'object') {
                return time;
            } else {
                return null;
            }
        },
        setYearRange(date, number, status) {
            if (this.isDate(date) && date !== null) {
                if (status === 'plus') {
                    return date.getFullYear() + number;
                } else {
                    return date.getFullYear() - number;
                }
            } else {
                return date;
            }
        },
        // ทำ dataClone
        setCloneData(data) {
            return JSON.parse(JSON.stringify(data));
        },
        // moveFocus
        moveFocus(event, refName, BoxCurrent) {
            if (BoxCurrent === 'Input' || BoxCurrent === 'Button') {
                event.preventDefault();
                if (this.$refs[refName].$el) {
                    this.$refs[refName].$el.focus();
                }
            } else if (BoxCurrent === 'InputNumber') {
                event.preventDefault();
                this.$refs[refName].$el.querySelector('.p-inputnumber input').focus();
            }
        },
        isFocused(refName) {
            return this.$refs[refName].$el === document.activeElement;
        },
        FocusRef_delay(refName, BoxCurrent) {
            setTimeout(() => {
                if (BoxCurrent === 'Input' || BoxCurrent === 'Button') {
                    if (this.$refs[refName].$el) {
                        this.$refs[refName].$el.focus();
                    }
                } else if (BoxCurrent === 'InputNumber') {
                    this.$refs[refName].$el.querySelector('.p-inputnumber input').focus();
                }
            }, 200);
        },
        resolveImageSrc(value) {
            if (value == null || value === '' || value === '-' || value === 'null' || value === 'undefined') {
                return '';
            }

            if (typeof value === 'string' && (value.startsWith('/uploads/') || value.startsWith('uploads/'))) {
                const normalizedPath = value.startsWith('/') ? value : `/${value}`;
                return `${this.$url_service}${normalizedPath}`;
            }

            return value;
        },
        /**
         * Prefer imagefullURL (file path), then fall back to legacy base64/URL columns.
         */
        pickRecordImage(record, ...legacyFields) {
            if (!record || typeof record !== 'object') {
                return this.resolveImageSrc(record);
            }

            const preferred = record.imagefullURL || record.imagefullurl || record.ImageFullURL;
            const preferredSrc = this.resolveImageSrc(preferred);
            if (preferredSrc) {
                return preferredSrc;
            }

            for (const field of legacyFields) {
                const src = this.resolveImageSrc(record[field]);
                if (src) {
                    return src;
                }
            }

            return '';
        },
        pickRecordImageRaw(record, ...legacyFields) {
            if (!record || typeof record !== 'object') {
                return record || '';
            }

            const preferred = record.imagefullURL || record.imagefullurl || record.ImageFullURL;
            if (preferred && preferred !== '-' && preferred !== 'null' && preferred !== 'undefined' && preferred !== '') {
                return preferred;
            }

            for (const field of legacyFields) {
                const value = record[field];
                if (value && value !== '-' && value !== 'null' && value !== 'undefined' && value !== '') {
                    return value;
                }
            }

            return '';
        }
    }
};

export default mixin;
